































// @ts-ignore
import { Card, createToken } from "vue-stripe-elements-plus";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import snackbar from "@/shared/snackbar";

@Component({
  components: { Card },
})
export default class ModalCreditcard extends Vue {

  @Prop()
  private currentSource!: any;

  // see https://stripe.com/docs/stripe.js#element-options for details
  private stripeOptions =  {};

  private complete = false;

  private async regist() {
    try {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      const response = await createToken();
      console.log(response);
      const result = await this.$store.dispatch("contract/updatePaymentMethod", response.token.id);
      snackbar.success(this, { message: "カード情報を登録しました。"});
    } catch (err) {
      console.log(err);
      snackbar.error(this, { message: `カード情報の登録に失敗しました。${err}`});
    } finally {
      // @ts-ignore buefy modal has this method
      this.$parent.close();
    }
  }
}
